export const DURATION = 2700;